import { useQuery } from '@tanstack/react-query';
import { getForm30ColorSettings, Form30ColorSettingsResponse } from '../../services/network/form30ColorSettings-api';
import { useEffect, useState } from 'react';

interface UseFetchForm30ColorSettingsParams {
    year: number | null;
    table_id: string | null;
    row_id: string | null;
    column_key: string | null;
}

export const useFetchForm30ColorSettings = ({
    year,
    table_id,
    row_id,
    column_key
}: UseFetchForm30ColorSettingsParams) => {
    const [shouldFetch, setShouldFetch] = useState(false);

    useEffect(() => {
        if (year && table_id && row_id && column_key) {
            setShouldFetch(true);
        } else {
            setShouldFetch(false);
        }
    }, [year, table_id, row_id, column_key]);

    const { data, isLoading, isError, error, refetch } = useQuery<Form30ColorSettingsResponse>({
        queryKey: ['form30ColorSettings', year, table_id, row_id, column_key],
        queryFn: async () => {
            if (!year || !table_id || !row_id || !column_key) {
                throw new Error('Отсутствуют обязательные параметры');
            }
            return await getForm30ColorSettings(year, table_id, row_id, column_key);
        },
        enabled: shouldFetch,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });

    return {
        colorSettings: data?.data || null,
        isLoading,
        isError,
        error,
        refetch
    };
};
